import * as React from 'react';
import './bamburgh-theme/assets/base.scss';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import NewVersionModal from './NewVersionModal'
import NotificationServiceWrapper from '@/components/NotificationServiceWrapper/NotificationServiceWrapper';
import { signalRUpdateConnectionStatus } from './store/SignalR';
import { useSignalRManualRefresh, useSignalRNegotiation } from 'prembid-shared-library-npm/signalr';
import { ConnectionStatus } from 'prembid-shared-library-npm/types';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDialog } from './components/containers/CustomDialog';
import { ScrollUpButton } from './components/composite/ScrollUpButton';
import { IoIosArrowUp } from 'react-icons/io';
import { ConfirmationDialogActivator } from './components/containers/ConfirmationDialogActivator';
import { ProgressSpinner } from './components/wrappers/ProgressSpinner';
import { AppThemeProvider } from './themes/AppTheme';

export default () => {
    const dispatch = useDispatch();
    useSignalRNegotiation({
        onConnectionStatusChange: (connectionStatus) => dispatch(signalRUpdateConnectionStatus(connectionStatus)),
    });

    // The live connection stops retrying after a few minutes (e.g. a tab left in the background on a bad network), so
    // reconnect when the tab is shown again or the browser comes back online, like mobile does on returning to the app.
    const connectionStatus = useSelector((state: any) => state.signalR?.connectionStatus);
    const { restartConnection } = useSignalRManualRefresh();
    const reconnectState = React.useRef({ connectionStatus, restartConnection });
    reconnectState.current = { connectionStatus, restartConnection };
    React.useEffect(() => {
        const reconnectIfDown = () => {
            if (document.visibilityState !== "visible") return;
            const { connectionStatus: status, restartConnection: restart } = reconnectState.current;
            if (status === ConnectionStatus.Disconnected || status === ConnectionStatus.Error || status === ConnectionStatus.TimedOut) restart();
        };
        document.addEventListener("visibilitychange", reconnectIfDown);
        window.addEventListener("online", reconnectIfDown);
        return () => {
            document.removeEventListener("visibilitychange", reconnectIfDown);
            window.removeEventListener("online", reconnectIfDown);
        };
    }, []);

    return <BrowserRouter>
        <AppThemeProvider>
        <React.StrictMode>
            {/* Back to top: same round white button and chevron as the carousel arrows (styled in modern.css). */}
            <ScrollUpButton ShowAtPosition={600} StopPosition={0} ContainerClassName="pb-scrolltop" TransitionClassName="pb-scrolltop--on">
                <IoIosArrowUp />
            </ScrollUpButton>
            <NotificationServiceWrapper />
            <ProgressSpinner />
            <CustomDialog />

            <Routes />
            <NewVersionModal />
            <ConfirmationDialogActivator />
        </React.StrictMode>
        </AppThemeProvider>
    </BrowserRouter>
}